import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '../api';

const detectPlatform = () => {
  const ua = navigator.userAgent || '';
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  let os = 'other';
  if (/iPhone|iPad|iPod/i.test(ua)) os = 'ios';
  else if (/Android/i.test(ua)) os = 'android';
  const installed = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  return { platform: isMobile ? 'mobile' : 'desktop', os, installed };
};

/**
 * PortalAnalyticsTracker - privacy-safe usage tracking for the customer portal.
 * Sends a page_view (with device/platform + installed flag) on each route change.
 * No UI. Mounted once inside the customer portal layout.
 */
export const PortalAnalyticsTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (lastPath.current === path) return;
    lastPath.current = path;
    const info = detectPlatform();
    analyticsAPI.track({ event_type: 'page_view', path, ...info }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PortalAnalyticsTracker;
